import type { AdminOrderData } from "../page";

interface Props {
  order: AdminOrderData;
}

export default function AdminOrderItems({ order }: Props) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-6">
      <h3 className="font-bold text-[#1a1a1a] text-sm mb-4 flex items-center gap-2">
        <div className="w-7 h-7 flex items-center justify-center bg-gray-50 rounded-lg">
          <i className="ri-box-3-line text-[#1a1a1a] text-sm"></i>
        </div>
        المنتجات
        <span className="mr-auto bg-gray-100 text-gray-500 text-xs px-2.5 py-0.5 rounded-full font-normal">
          {order.items.length} {order.items.length === 1 ? "منتج" : "منتجات"}
        </span>
      </h3>

      <div className="flex flex-col gap-3">
        {order.items.map((item, idx) => (
          <div key={idx} className="flex items-center gap-4 bg-gray-50 rounded-xl p-3.5 hover:bg-gray-100 transition-colors">
            <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 bg-gray-200 border border-gray-200">
              {item.image ? (
                <img src={item.image} alt={item.nameAr} className="w-full h-full object-cover object-top" />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <i className="ri-image-line text-gray-400 text-xl"></i>
                </div>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-bold text-[#1a1a1a] text-sm truncate">{item.nameAr}</p>
              <div className="flex items-center gap-3 mt-1">
                <span className="text-xs text-gray-500 flex items-center gap-1">
                  <i className="ri-stack-line text-gray-400 text-xs"></i>
                  الكمية: <strong>{item.qty}</strong>
                </span>
                <span className="text-gray-300 text-xs">·</span>
                <span className="text-xs text-gray-500">
                  {item.price.toLocaleString("ar-SA")} ر.س / قطعة
                </span>
              </div>
            </div>
            <div className="flex-shrink-0 text-left">
              <p className="font-black text-[#1a1a1a] text-base">{(item.price * item.qty).toLocaleString("ar-SA")}</p>
              <p className="text-xs text-gray-400">ر.س</p>
            </div>
          </div>
        ))}
      </div>

      {/* Items total */}
      <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
        <span className="text-sm text-gray-500">مجموع المنتجات</span>
        <span className="font-bold text-[#1a1a1a]">{order.totalPrice.toLocaleString("ar-SA")} ر.س</span>
      </div>
    </div>
  );
}
